import React from 'react';
import PropTypes from 'prop-types';
import Select from "react-select";
import {getStringParamOrDefault, updateQueryStringForState} from "../../utils/urlBuilder";
import {toTitleCase} from "../Components/ReactTable/helpers";

const MULTI_VALUE_BACKGROUND_COLOR = "#1271B2";
const MULTI_VALUE_TEXT_COLOR = "#FEFEFE";

const ReactTableFilterDropdown = ({
                                      id,
                                      onChange,
                                      options,
                                      selectedValue,
                                      selectedValues,
                                      queryStringParamId,
                                      isClearable = false,
                                      isMulti = false,
                                      placeholder = undefined,
                                      height = 32,
                                      width = '100%'
                                  }) => {
    const paramValue = queryStringParamId && getStringParamOrDefault(queryStringParamId, undefined);
    const optionValue = paramValue ? paramValue : selectedValue;
    const heightProp = isMulti ? "minHeight" : "height";
    const controlHeight = isMulti ? {minHeight: height} : {height, minHeight: height};
    const styles = {
        container: (base) => ({...base, width, textAlign: "left"}),
        control: (base) => ({...base, ...controlHeight, alignContent: "center"}),
        valueContainer: (base) => ({...base, [heightProp]: height, alignContent: "center"}),
        indicatorsContainer: (base) => ({...base, [heightProp]: height, alignItems: "center"}),
        input: (base) => ({...base, margin: 0}),
        singleValue: (base) => ({...base, margin: 0}),
        placeholder: (base) => ({
            ...base,
            margin: 0,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
        }),
        multiValue: (base) => ({...base, backgroundColor: MULTI_VALUE_BACKGROUND_COLOR}),
        multiValueLabel: (base) => ({...base, color: MULTI_VALUE_TEXT_COLOR}),
        multiValueRemove: (base) => ({...base, color: MULTI_VALUE_TEXT_COLOR})
    };

    const selectedOptions = isMulti
        ? (selectedValues || []).map(value => options.find(option => option.value === value)).filter(Boolean)
        : options.find(option => option.value === optionValue);

    const valuesFromSelection = (selection) => isMulti
        ? (selection || []).map(option => option.value)
        : selection && selection.value;

    return <div className={"react-table-dropdown-filter-container"} data-testid={`${id}-filter-dropdown-component-container`}>
        <Select
            id={`${id}_filter_dropdown`}
            placeholder={placeholder !== undefined ? placeholder : `${toTitleCase(id)}...`}
            menuPosition={"fixed"}
            menuPlacement={"bottom"}
            menuShouldBlockScroll={true}
            maxMenuHeight={200}
            className={"react-table-filter-dropdown"}
            classNamePrefix={"react-table-filter-dropdown"}
            value={selectedOptions}
            options={options}
            onChange={(selection) => {
                const newValue = valuesFromSelection(selection);
                onChange(newValue);
                queryStringParamId && updateQueryStringForState({
                    [queryStringParamId]: isMulti ? (newValue || []).join(',') : (newValue || '')
                });
            }}
            isClearable={isClearable}
            isMulti={isMulti}
            backspaceRemovesValue={false}
            styles={styles}
        />
    </div>
};

ReactTableFilterDropdown.propTypes = {
    id: PropTypes.string.isRequired,
    isClearable: PropTypes.bool,
    isMulti: PropTypes.bool,
    options: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    queryStringParamId: PropTypes.string,
    selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    selectedValues: PropTypes.array,
    height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default ReactTableFilterDropdown;
